<template>
	<frontend-layout>
		<Head>
			<title>{{ $t("announcements") }} - {{ $t("siteTitle") }}</title>
		</Head>
		<!-- <template #header>
            <h1 class="page-title p-0">公告列</h1>
        </template> -->

		<template #breadcrumb>
			<div class="pageInfo mb-2 p-1">
				<div class="page-breadcrumb float-sm-right">
					<ol class="breadcrumb">
						<li class="breadcrumb-item">
							<InertiaLink
								:href="'/'"
								:class="{
									active: $page.url === '/',
								}">
								{{ $t("home") }}
							</InertiaLink>
						</li>
						<li class="breadcrumb-item">
							{{ $t("announcements") }}
						</li>
					</ol>
				</div>
			</div>
		</template>
		<div class="announcement">
			<h1>{{ $t("announcements") }}</h1>
			<div class="row">&nbsp;</div>
		</div>
		<section>
			<div class="container">
				<newsList></newsList>
			</div>
		</section>
	</frontend-layout>
</template>

<script>
// import components
import FrontendLayout from "@/Frontend/Shared/Layout";
import newsList from "@/Frontend/Components/newsList";

export default {
	name: "announcements",
	props: {},
	data() {
		return {};
	},
	methods: {},
	mounted() {},

	components: {
		FrontendLayout,
		newsList,
	},
};
</script>

<style scoped>
.announcement {
	text-align: center;
}
</style>
